/*
  =====================================================
  Lee Flora Wholesale — Wedding Flowers v2 Page JS
  FILE: assets/lfw-wedding-v2.js
  SCOPE: Only loaded on the page.wedding-flower-v2 template
         (loaded via snippet 'lfw-wedding-v2-assets' in theme.liquid head).
  The page is split into multiple Shopify sections, each wrapped in
  .lfw-wd-v2 — so all queries are scoped to '.lfw-wd-v2 …' (which spans
  every section) rather than a single wrapper. Still never touches theme UI.
  =====================================================
*/
(function () {
  if (!document.querySelector('.lfw-wd-v2')) return;


  // FAQ accordion — one open at a time (all FAQ items live under #faqReal)
  document.querySelectorAll('.lfw-wd-v2 #faqReal .qa button').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var qa = btn.closest('.qa');
      var isOpen = qa.classList.contains('open');
      document.querySelectorAll('.lfw-wd-v2 #faqReal .qa').forEach(function (o) { o.classList.remove('open'); });
      if (!isOpen) qa.classList.add('open');
    });
  });

  // Scroll-reveal — spans every section wrapper
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('in'); io.unobserve(en.target); }
    });
  }, { threshold: .12 });
  document.querySelectorAll('.lfw-wd-v2 .reveal').forEach(function (el) { io.observe(el); });

  // Mobile burger menu (in the header section) — animated open/close via classes
  var burger = document.querySelector('.lfw-wd-v2 .burger');
  var menu = document.querySelector('.lfw-wd-v2 .menu');
  if (burger && menu) {
    burger.addEventListener('click', function () {
      burger.classList.toggle('open');
      menu.classList.toggle('open');
    });
    // close the menu after tapping a link
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        burger.classList.remove('open');
        menu.classList.remove('open');
      });
    });
  }
})();
